import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { UtilsService } from '../../utils/utils';
import { environment } from 'src/environments/environment';

@Injectable()
export class ImportacaoFeriasService {

    routePrefix: string = 'Ferias'
    constructor(
        private httpClient: HttpClient,
        private utilsService: UtilsService,
    ) { }

    pesquisar(empresaId = ''): Observable<any> {
        return this.httpClient.get<Array<any>>(`${environment.urlBase}${this.routePrefix}/Buscar${this.routePrefix}PorEmpresaId?empresaId=${empresaId}`)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    pesquisarPorUsuarioId(usuarioId = ''): Observable<any> {
      return this.httpClient.get<Array<any>>(`${environment.urlBase}${this.routePrefix}/Buscar${this.routePrefix}PorUsuarioId?usuarioId=${usuarioId}`)
          .pipe(
              retry(1),
              catchError(this.utilsService.handleError));
  }

    pesquisarImportacaoPorId(id = ''): Observable<any> {
        return this.httpClient.get<Array<any>>(`${environment.urlBase}${this.routePrefix}/Buscar${this.routePrefix}PorId?id=${id}`)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    importar(data = {}): Observable<any> {
        return this.httpClient.post<any>(`${environment.urlBase}${this.routePrefix}/Importar${this.routePrefix}`, data)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    excluirPorId(id = ''): Observable<any> {
        return this.httpClient.post<any>(`${environment.urlBase}${this.routePrefix}/Excluir${this.routePrefix}PorId?id=${id}`, {})
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    pesquisarFeriasPorColaboradorId(id = ''): Observable<any> {
        return this.httpClient.get<Array<any>>(`${environment.urlBase}${this.routePrefix}/Buscar${this.routePrefix}PorColaboradorId?colaboradorId=${id}`)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    pesquisarFeriasPorUsuarioId(id = ''): Observable<any> {
      return this.httpClient.get<Array<any>>(`${environment.urlBase}${this.routePrefix}/Buscar${this.routePrefix}PorUsuarioId?usuarioId=${id}`)
          .pipe(
              retry(1),
              catchError(this.utilsService.handleError));
  }

    pesquisarFeriasPorId(id = ''): Observable<any> {
        return this.httpClient.get<Array<any>>(`${environment.urlBase}${this.routePrefix}/Buscar${this.routePrefix}PorId?id=${id}`)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    pesquisarFeriasPorEmpresaId(id = ''): Observable<any> {
        return this.httpClient.get<Array<any>>(`${environment.urlBase}${this.routePrefix}/Buscar${this.routePrefix}PorEmpresaId?empresaId=${id}`)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }
}
